export enum HttpMethodEnum {
    POST = "POST",
    GET = "GET",
    PUT = "PUT",
    DELETE = "DELETE"
}

export enum ValidationCode {
    ERROR = -1,
    VALID = 2,
    NONE = 0
}